import { render, staticRenderFns } from "./AgencyRoot.vue?vue&type=template&id=5f3c7674&scoped=true&"
import script from "./AgencyRoot.vue?vue&type=script&lang=js&"
export * from "./AgencyRoot.vue?vue&type=script&lang=js&"
import style0 from "./AgencyRoot.vue?vue&type=style&index=0&id=5f3c7674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c7674",
  null
  
)

export default component.exports